import {ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy} from '@angular/router';

export class CustomReuseStrategy implements RouteReuseStrategy {
    private storedHandles = new Map<string, DetachedRouteHandle>();

    private getRoutePath(route: ActivatedRouteSnapshot): string {
        return route.pathFromRoot.map(r => r.routeConfig?.path).filter(Boolean).join('/');
    }

    public shouldDetach(route: ActivatedRouteSnapshot): boolean {
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        return !!route.data?.reuse;
    }

    public store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
        const path = this.getRoutePath(route);

        // eslint-disable-next-line no-null/no-null
        if (handle === null) {
            this.storedHandles.delete(path);
        } else {
            this.storedHandles.set(path, handle);
        }
    }

    public shouldAttach(route: ActivatedRouteSnapshot): boolean {
        const path = this.getRoutePath(route);
        return this.storedHandles.has(path);
    }

    public retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
        const path = this.getRoutePath(route);
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions,no-null/no-null
        return this.storedHandles.get(path) || null;
    }

    public shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        return future.routeConfig === curr.routeConfig;
    }
}
